import type {
  AttributesAndExtraAtrributesData,
  IADatabaseConfigBaseState
} from '@dfg/brahma-types';
import { IADataBaseConfigKeys } from '@dfg/brahma-types';
import type { IADatabaseContextReducerState } from './iaDatabase.types';

export const iaDatabaseInititalState: IADatabaseContextReducerState = {
  iaInfo: {},
  configData: {
    attributeType: {
      key: IADataBaseConfigKeys.attributeType,
      data: [],
      isFetched: false
    },
    documentType: {
      key: IADataBaseConfigKeys.documentType,
      data: [],
      isFetched: false
    },
    componentType: {
      key: IADataBaseConfigKeys.componentType,
      data: [],
      isFetched: false
    }
  }
};

export const IA_OFFICE_ENTITY_EMPTY_DATA: IADatabaseConfigBaseState<AttributesAndExtraAtrributesData> =
  {
    data: {},
    isFetched: false,
    key: ''
  };
